import { match } from "ts-pattern";

export type ModelFamily = "claude" | "gpt" | "gemini";

export const getModelFamilyFromModelName = (modelName: string) =>
  match<string, ModelFamily>(modelName)
    .when((m) => m?.includes("claude"), () => "claude")
    .when((m) => m?.includes("gpt"), () => "gpt")
    .when((m) => m?.includes("gemini"), () => "gemini")
    .run();

export class AgentModel {
  constructor(
    public modelName: string,
    public displayName: string,
    public modelFamily: ModelFamily,
    public isDefault: boolean,
    public reasoningEffort?: string,
  ) {}

  get key(): string {
    return this.reasoningEffort ? `${this.modelName}:::${this.reasoningEffort}` : this.modelName;
  }
}
